"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Модалка появляется после нажатия на "Показать контакты" (страница поиска вакансий) */
const vacancySearchContactsSignupButtonClick = ({ vacancyId, ...analyticsParams } = {}) => analytics_js_1.default.sendHHEventButtonClick("vacancy_contacts_signup", { vacancyId, ...analyticsParams });
exports.default = vacancySearchContactsSignupButtonClick;
